export default __webpack_public_path__ + "static/media/resetForgotPassword.d549b5ba.svg";